module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "media-page"
    }
  }, [(!_vm.$route.params.piece) ? _c('section', {
    attrs: {
      "id": "media-albums"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.fetchingAlbumStatus === 'fetching') ? _c('div', {
    staticClass: "loader-container"
  }, [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (_vm.fetchingAlbumStatus !== 'fetching' && !_vm.reorderAlbumMode && !_vm.addAlbumMode) ? _c('ul', {
    staticClass: "album-list"
  }, [_vm._l((_vm.albums), function(album) {
    return _c('router-link', {
      class: {
        selected: album.stringUrl === _vm.$route.params.album
      },
      attrs: {
        "tag": "li",
        "to": ("/Game/" + (_vm.$route.params.game) + "/Media/" + (album.stringUrl))
      }
    }, [(album.hasAvatar) ? _c('img', {
      staticClass: "media-avatar",
      attrs: {
        "src": ("https://www.develteam.com/userdata/avatars/media_" + (album.id) + ".jpg"),
        "alt": album.title + ' album',
        "title": album.title + ' album'
      }
    }) : _c('img', {
      staticClass: "media-avatar",
      attrs: {
        "src": "https://www.develteam.com/userdata/avatar_blank_100.jpg",
        "alt": album.title + ' album',
        "title": album.title + ' album'
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(album.title))])])
  }), _vm._v(" "), (Object.keys(_vm.albums).length === 0 && !_vm.canEdit) ? _c('div', {
    staticClass: "no-albums"
  }, [_vm._v("\n                    This Game Project has not Uploaded any Media\n                ")]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('li', {
    class: [{
      selected: _vm.addAlbumMode
    }, 'add-album-container'],
    on: {
      "click": _vm.enterAddAlbumMode
    }
  }, [_c('div', {
    staticClass: "media-avatar add-album"
  }, [_c('i', {
    staticClass: "fas fa-plus"
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Add Album")])]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('li', {
    class: [{
      selected: _vm.reorderAlbumMode
    }, 'reorder-album-container'],
    on: {
      "click": _vm.enterReorderAlbumMode
    }
  }, [_c('div', {
    staticClass: "media-avatar reorder-album"
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  })]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("Reorder Albums")])]) : _vm._e()], 2) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.addAlbumMode) ? _c('new-album-form', {
    attrs: {
      "page-type": "game",
      "page-id": _vm.gameId
    },
    on: {
      "doneEditing": function($event) {
        _vm.addAlbumMode = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.reorderAlbumMode) ? _c('reorder-album-form', {
    attrs: {
      "page-type": "game",
      "page-id": _vm.gameId
    },
    on: {
      "doneEditing": function($event) {
        _vm.reorderAlbumMode = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.params.album) ? _c('media-piece-list', {
    attrs: {
      "page-type": "game",
      "page-id": _vm.gameId,
      "medias-id": _vm.mediasId,
      "can-edit": _vm.canEdit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$route.params.piece) ? _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.exitSinglePieceView
    }
  }, [_vm._v("View Entire Portfolio")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4bbd558!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Pages/Game/SubPages/GameMedia.vue
// module id = 910
// module chunks = 2